<template>
    <main-content>
        <div v-if="$can('read-sensitive-info', 'user')">
            <div>
                <button  class="btn btn-primary m-2" data-toggle="modal" data-target="#description_modal">ثبت کاربر جدید</button>
                <div id="description_modal" class="modal fade rtl" role="dialog">
                <div class="modal-dialog">
                    <!-- Modal content-->
                    <div class="modal-content bg-white">
                        <div id="data_sheet" class="modal-body mb-4">
                        <div class="modal-header">
                            <h4 class="modal-title bg-white">ثبت کاربر جدید</h4>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="m-4">
                            <form @submit.prevent="registerNewUser" method="post">
                            <kt-form-section>
                                <kt-form-row>
                                        <kt-col xs="12" sm="6" md="10">
                                            <kt-form-group>
                                                <kt-form-label for="first_name">
                                                    {{ $t('label.first_name') }}
                                                </kt-form-label>
                                                <kt-form-control ref="first_name" dir="ltr" name="first_name" id="first_name" v-model="new_user.first_name"/>
                                            </kt-form-group>
                                        </kt-col>
                                </kt-form-row>
                                <kt-form-row>
                                        <kt-col xs="12" sm="6" md="10">
                                            <kt-form-group>
                                                <kt-form-label for="last_name">
                                                    {{ $t('label.last_name') }}
                                                </kt-form-label>
                                                <kt-form-control ref="last_name" dir="ltr" name="last_name" id="last_name" v-model="new_user.last_name" />
                                            </kt-form-group>
                                        </kt-col>
                                </kt-form-row>
                                    <kt-form-row>
                                        <kt-col xs="12" sm="6" md="10">
                                            <kt-form-group>
                                                <kt-form-label for="phone">
                                                    {{ $t('label.phone') }}
                                                </kt-form-label>
                                                <kt-form-control ref="phone" dir="ltr" name="phone" id="phone" v-model="new_user.phone" />
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-form-row>
                                    <kt-form-row>
                                        <kt-col xs="12" sm="6" md="10">
                                            <kt-form-group>
                                                <kt-form-label for="password">
                                                    {{ $t('label.password') }}
                                                </kt-form-label>
                                                <kt-form-control ref="password" dir="ltr" name="password" id="password" v-model="new_user.password"/>
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-form-row>
                                    <kt-form-row>
                                        <kt-col xs="12" sm="6" md="6">
                                            <kt-form-group>
                                                <kt-form-label for="status">
                                                    {{ $t('label.status') }}
                                                </kt-form-label>
                                                <select size="1" id="status" class="form-control" name="status" v-model="new_user.status">
                                                    <option
                                                            v-bind:key="index"
                                                            v-for="(status, index) in statuses"
                                                            v-bind:value="status.value"
                                                    >
                                                        {{ status.name }}
                                                    </option>
                                                </select>
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                    <kt-row>
                                        <kt-col xs="12" sm="6" md="6">
                                            <button
                                                class="btn btn-success btn-wide float-left"
                                                size="md"
                                                type="submit"
                                                id="reg_btn"
                                            >
                                            {{$t('auth.btn.submit_user')}}
                                            </button>
                                        </kt-col>
                                    </kt-row>
                                </kt-form-section>
                            </form>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            </div>
                <user-filter :action="filterAction" :exportExcel="exportToExcel"></user-filter>
                <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
        </div>
        <div v-else>
            {{ $t('exception.access_denied') }}
        </div>
    </main-content>
</template>

<script>
    import $ from "jquery";
    import mainContent from "@/components/main-content";
    import { mapGetters } from "vuex";
    import columns from "./datatable/columns";
    import { ApiUrl } from "@/common/api.service";
    import { AuthorizationHeader } from "@/common/jwt.service";
    import { userStatusStr, userStatus } from '@/constants/userStatus'
    import { actionsColumn, userFilter } from "./components";
    import axios from "axios";
    import { userService } from '@/common/api.service'
    export default {
        components: {
            mainContent,
            userFilter,
        },

        data() {
            return {
               statuses: [
                {
                    name: null,
                    value: null
                },
                {
                    name: userStatusStr.ACTIVE,
                    value: userStatus.ACTIVE
                },
                {
                    name: userStatusStr.REMOVED,
                    value: userStatus.REMOVED
                },
                {
                    name: userStatusStr.PENDING,
                    value: userStatus.PENDING
                },
                {
                    name: userStatusStr.IS_AUTHENTICATED,
                    value: userStatus.IS_AUTHENTICATED
                },
                {
                    name: userStatusStr.IS_AUTHENTICATED_PENDING,
                    value: userStatus.IS_AUTHENTICATED_PENDING
                },
            ],
                headerAction: {
                    left: "10px",
                    top: "10px",
                    position: "absolute",
                },
                query: { newsid: 2 },
            };
        },
        computed: {
          ...mapGetters('user', [
            'new_user'
        ]),
            datatableProps() {
                return {
                    id: "user_datatable",
                    data: {
                        type: "remote",
                        source: {
                            read: {
                                url: this.$route.params.newsid
                                    ? ApiUrl.path(
                                        "news/users/see?newsid=" + this.$route.params.newsid + ""
                                    )
                                    : ApiUrl.path("user"),
                                method: "GET",
                                headers: AuthorizationHeader,
                                map: function (res) {
                                    return res.data.data;
                                },
                                params: {
                                    query: this.query,
                                },
                            },
                        },
                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {},
                    pagination: false,
                    sortable: true,
                    columns: columns,
                    actions: actionsColumn,
                };
            },
        },
        methods: {
            filterAction(e, query) {
                this.query = query;
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload();
                }
            },
            exportToExcel(e, query){
                this.query = query
                axios({
                    url: ApiUrl.path('user/excel-export'),
                    method: 'GET',
                    params: this.query,
                    responseType: 'blob',
                }).then((response) => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'users.xlsx');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                });
            },
            registerNewUser(e){
                 let btn = $('#reg_btn')
                 let form = $(e.target)
            userService.registerUserByAdmin(this.new_user)
            .then(response => {
                $('#description_modal').modal('hide')
                this.$refs.datatable.reload();
                this.clearFormData();
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            });
            },
          clearFormData() {
            const vm = this;
            Object.keys(this.new_user).forEach(function (key){
                  vm.new_user[key] = ''
        });
    },
        },
    };
</script>

<style>
</style>
